import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IGroup, IPlayerGroup } from "@grassrootly/api";

export interface GroupsState {
  playerGroups: { [key: number]: IPlayerGroup };
  // Trying to avoid mapping back to array everytime we need player groups as array
  playerGroupsArray: IPlayerGroup[];
  groups: { [key: number]: IGroup };
}

const initialState: GroupsState = {
  playerGroups: [],
  playerGroupsArray: [],
  groups: {},
};

const groupsSlice = initReducer({
  name: "groups",
  initialState,
  reducers: {
    setGroups: (state: GroupsState, action: PayloadAction<IGroup[]>) => {
      const newGroups = action.payload.reduce((acc, group) => {
        acc[group.id] = group;
        return acc;
      }, {} as { [key: number]: IGroup });
      state.groups = { ...state.groups, ...newGroups };
    },
    updateGroup: (state, action: PayloadAction<IGroup>) => {
      const group = action.payload;
      state.groups[group.id] = group;
    },
    setPlayerGroups: (state: GroupsState, action: PayloadAction<IPlayerGroup[]>) => {
      const mapedGames: { [key: number]: IPlayerGroup } = {};
      action.payload.forEach((g) => {
        mapedGames[g.id] = g;
      });
      // Replace existing groups instead of merging to prevent stale data
      state.playerGroups = mapedGames;
      state.playerGroupsArray = action.payload;
    },
    setPlayerGroup: (state: GroupsState, action: PayloadAction<IPlayerGroup>) => {
      state.playerGroups = { ...state.playerGroups, [action.payload.id]: action.payload };
    },
    removePlayerGroup: (state: GroupsState, action: PayloadAction<number>) => {
      const groupId = action.payload;
      const { [groupId]: removed, ...remainingGroups } = state.playerGroups;
      state.playerGroups = remainingGroups;
      state.playerGroupsArray = Object.values(remainingGroups);
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<GroupsState> = {
  key: "groups",
  storage: AsyncStorage,
};

export const groupsActions = groupsSlice.actions;

export default createPersistReducer(persistConfig, groupsSlice.reducer);
